import z from 'zod';
import { FormElementType } from './globals.type';

export enum AgeGroupType {
  AGE_20 = '20',
  AGE_30 = '30',
  AGE_40 = '40',
  AGE_50 = '50',
  AGE_MORE = 'more',
}
export interface FranchiseReserveRequest {
  realname: string;
  ageGroup: AgeGroupType;
  phoneNumber: string;
  email: string;
  regionTxt: string;
  budget: string;
  content: string;
}

export interface FranchiseReserveResponse {
  id: number;
  realname: string;
  ageGroup: AgeGroupType;
  phoneNumber: string;
  email: string;
  regionTxt: string;
  budget: string;
  content: string;
  datetime: string;
}

export const formSchema = z.object({
  realname: z
    .string()
    .min(2, '이름을 2자 이상 입력해주세요')
    .max(20, '이름을 20자 이하로 입력해주세요')
    .regex(/^[가-힣a-zA-Z\s]+$/, '이름은 한글 또는 영문만 입력 가능합니다'),
  ageGroup: z.nativeEnum(AgeGroupType, {
    errorMap: () => ({ message: '점주 연령대를 선택해주세요.' }),
  }),
  phoneNumber: z
    .string()
    .min(10, '연락처를 정확히 입력해주세요')
    .max(13, '연락처를 정확히 입력해주세요')
    .regex(/^01[016789]-?\d{3,4}-?\d{4}$/, '연락처 형식이 올바르지 않습니다'),
  email: z
    .string()
    .min(1, { message: '이메일을 입력해주세요.' })
    .email({ message: '올바른 이메일 형식이 아닙니다.' }),
  regionTxt: z.string().min(1, { message: '희망지역을 입력해주세요.' }),
  budget: z.string().min(1, { message: '예산을 입력해주세요.' }),
  content: z.string().min(1, { message: '상담내용을 입력해주세요.' }),
  privacyAgreement: z.boolean().refine((val) => val === true, {
    message: '개인정보 수집 이용에 동의해주세요',
  }),
});

export type FormValues = z.infer<typeof formSchema>;

export interface FormTextFieldProps {
  label: string;
  name: keyof FormValues; // FormValues의 키로 제한
  placeholder: string;
  isRequired?: boolean;
  elementType: FormElementType;
}
